import { EchoLevelFilterCheckbox } from '@/js/services/api/filter/types';

export type LevelPathNode = Omit<EchoLevelFilterCheckbox, 'children'> & {
    path: string;
    children: Record<string, LevelPathNode>;
};

/** The organisational table path holds group ids, so groups are keyed by groupId. */
const toPathKey = (item: EchoLevelFilterCheckbox): string =>
    item.agentId ? item.id : item.groupId;

export function createHierarchicalEchoFilterCheckboxMap(
    items: EchoLevelFilterCheckbox[],
    parentPath: string = ''
): Record<string, LevelPathNode> {
    const map: Record<string, LevelPathNode> = {};

    for (const item of items) {
        const key = toPathKey(item);
        const currentPath = parentPath ? `${parentPath}/${key}` : key;
        map[key] = {
            ...item,
            path: currentPath,
            children: createHierarchicalEchoFilterCheckboxMap(item.children, currentPath),
        };
    }

    return map;
}
